/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional text or structured reason for the feedback
 */
export type StudentEvaluationFeedbackRequestReason = string | null;
